export default __webpack_public_path__ + "c340fbbe8288f08841441f2daf7b0c98.svg";